import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraTestingExercise } from '../../models/doraTestingExercise.ts';

interface DoraTestingExerciseState {
  doraTestingExercises: DoraTestingExercise[];
  selectedDoraTestingExercise: DoraTestingExercise | null;
}

const initialState: DoraTestingExerciseState = {
  doraTestingExercises: [],
  selectedDoraTestingExercise: null,
};

const doraTestingExerciseSlice = createSlice({
  name: 'doraTestingExercise',
  initialState,
  reducers: {
    setDoraTestingExercises(state, action: PayloadAction<DoraTestingExercise[]>) {
      state.doraTestingExercises = action.payload;
    },
    addDoraTestingExercise(state, action: PayloadAction<DoraTestingExercise>) {
      state.doraTestingExercises.push(action.payload);
    },
    updateDoraTestingExercise(state, action: PayloadAction<DoraTestingExercise>) {
      const index = state.doraTestingExercises.findIndex(exercise => exercise.id === action.payload.id);
      if (index !== -1) state.doraTestingExercises[index] = action.payload;
    },
    removeDoraTestingExercise(state, action: PayloadAction<number>) {
      state.doraTestingExercises = state.doraTestingExercises.filter(exercise => exercise.id !== action.payload);
    },
    setSelectedDoraTestingExercise(state, action: PayloadAction<DoraTestingExercise | null>) {
      state.selectedDoraTestingExercise = action.payload;
    },
  },
});

export const {
  setDoraTestingExercises,
  addDoraTestingExercise,
  updateDoraTestingExercise,
  removeDoraTestingExercise,
  setSelectedDoraTestingExercise,
} = doraTestingExerciseSlice.actions;

export const selectDoraTestingExercises = (state: RootState) => state.doraTestingExercise.doraTestingExercises;
export const selectSelectedDoraTestingExercise = (state: RootState) => state.doraTestingExercise.selectedDoraTestingExercise;

export default doraTestingExerciseSlice.reducer;
